import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VmInfo } from '../../../../core/models/node';
import { NodeService } from '../../../../core/services/node.service';

@Component({
  selector: 'app-update-bm-node',
  templateUrl: './update-bm-node.component.html',
  styleUrls: ['./update-bm-node.component.scss']
})
export class UpdateBmNodeComponent implements OnInit {
  constructor(public dialog: MatDialogRef<UpdateBmNodeComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { depName: string; nodeName: string },
    private nodeService: NodeService,
  ) { }

  vmId: string;
  instanceType: string;
  publicIp: string;
  privateIp: string;
  bmCIp: string;
  mac: string;
  startCommand: string;
  stopCommand: string;
  restartCommand: string;

  ngOnInit(): void {
    this.nodeService.getNodeInfo(this.data.depName, this.data.nodeName)
      .subscribe((data) => {
        if (!data) return;

        let node = <VmInfo>JSON.parse(JSON.stringify(data));
        this.vmId = node.vmId;
        this.instanceType = node.instanceType;
        this.publicIp = node.publicIp;
        this.privateIp = node.privateIp;
        this.bmCIp = node.bmcIp;
        this.mac = node.macAddress;
        this.startCommand = node.startCommand;
        this.stopCommand = node.stopCommand;
        this.restartCommand = node.restartCommand;
      }
      );
  }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit() {
    this.dialog.close(false);
    this.nodeService.setNodeInfo(this.data.depName, this.data.nodeName, {
      bmcIp: this.bmCIp,
      startCommand: this.startCommand,
      stopCommand: this.stopCommand,
      restartCommand: this.restartCommand,
      publicIp: this.publicIp,
      privateIp: this.privateIp,
      macAddress: this.mac,
      resetCommand: null,
      vmId: this.vmId,
      instanceType: this.instanceType
    }).subscribe(() => {
    });
  }
}
